// extracted by mini-css-extract-plugin
export default {"shadow":"RWbF"};